import {
  deleteContractSubtype,
  clearContractSubtypeAction,
} from 'actions/contracts/contractSubtypeActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractSubtypeDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractSubtypeAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractSubtype(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract subtype? This can not be
        undone.
      </div>
    </form>
  )
}

export default ContractSubtypeDelete
